import type { JSX } from 'react';
import { useState } from 'react';
import { useApercuMedia, useMediasDeRattachement } from '../../api/medias.js';
import { Cimaise, type CimaiseProps } from './Cimaise.js';
import styles from './VisuelExposition.module.css';

/** La première vue d’accrochage illustre l’exposition ; le schéma reste le repli. */
export function VisuelExposition({
  galerie,
  expositionId,
  ...cimaise
}: CimaiseProps & { galerie: string; expositionId: string }): JSX.Element {
  const medias = useMediasDeRattachement(galerie, 'exhibition', expositionId);
  const premier = medias.data
    ?.filter((media) => !media.supprime && media.type === 'accrochage')
    .toSorted((a, b) => a.ordre - b.ordre || a.id.localeCompare(b.id))[0];
  const apercu = useApercuMedia(galerie, premier?.id ?? null);
  const [urlEnErreur, setUrlEnErreur] = useState<string | null>(null);

  return apercu.data && apercu.data !== urlEnErreur ? (
    <img
      className={styles.image}
      data-taille={cimaise.taille ?? 'carte'}
      src={apercu.data}
      alt=""
      loading="lazy"
      onError={() => setUrlEnErreur(apercu.data ?? null)}
    />
  ) : (
    <Cimaise {...cimaise} />
  );
}
